<template>
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14 27.9993L23.3333 37.3327L42 18.666"
      stroke="currentColor"
      stroke-width="4.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.9997 53.6663C42.175 53.6663 53.6663 42.175 53.6663 27.9997C53.6663 13.8244 42.175 2.33301 27.9997 2.33301C13.8244 2.33301 2.33301 13.8244 2.33301 27.9997C2.33301 42.175 13.8244 53.6663 27.9997 53.6663Z"
      stroke="currentColor"
      stroke-width="4.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
